@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;
  overflow-x: hidden;
}

.grid {
  position: relative;
  display: block;
  min-height: 200px;
  z-index: 1;
  overflow: visible;
  width: 100%;
  height: 100%;
}

.wrapper {
  flex-direction: column;
  .dashboards-header {
    display: none;
    padding: calc(var(--spacer) * 3) calc(var(--spacer) * 2) 0;
    margin-bottom: calc(var(--spacer) * 3);
    color: var(--chart-300-icon-buttons);
  }

  .dashboard-loader {
    display: none;
    padding: 34px 34px 34px 16px;
  }

  &.is-error {
    .dashboards-header {
      display: none;
    }
    .dashboards,
    .dashboard-empty {
      display: none;
    }
    .dashboard-error {
      display: block;
    }
  }

  &.is-empty {
    .dashboards-header {
      display: none;
    }
    .dashboards {
      display: none;
    }
    .dashboard-empty {
      display: block;
    }
  }

  &.is-loading {
    .dashboards-header {
      display: block;
    }
    .dashboards {
      display: none;
    }
    .dashboard-error,
    .dashboard-empty {
      display: none;
    }
    .dashboard-loader {
      display: block;
    }
  }

  .dashboard-error,
  .dashboard-empty {
    height: auto;
    width: 500px;
    margin: auto;
  }
}

:host([data-display-mode='report']) {
  .title {
    display: none;
  }
}
